// Puñito — JS propio, vanilla, sin librerías externas.
document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initGaleria();
  initBundles();
  initCantidad();
  initFaq();
  initBarraFija();
});

// ---------- Reveal on scroll ----------
function initReveals() {
  var els = document.querySelectorAll('.pu-reveal, .pu-reveal-stagger');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('pu-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

// ---------- Galería: miniatura -> imagen/video principal ----------
function initGaleria() {
  var principal = document.querySelector('[data-pu-galeria-principal]');
  var thumbs = document.querySelectorAll('[data-pu-thumb]');
  if (!principal || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var template = thumb.querySelector('[data-pu-thumb-media]');
      if (!template) return;
      principal.innerHTML = template.innerHTML;
      thumbs.forEach(function (t) { t.classList.remove('pu-thumb-activo'); });
      thumb.classList.add('pu-thumb-activo');
    });
  });
}

// ---------- Selector de bundle (variantes) ----------
function initBundles() {
  var wrap = document.querySelector('[data-pu-bundles]');
  if (!wrap) return;
  var opciones = wrap.querySelectorAll('[data-pu-bundle]');
  var inputId = document.querySelector('[data-pu-input-id]');
  var precioActual = document.querySelector('[data-pu-precio-actual]');
  var precioAnterior = document.querySelector('[data-pu-precio-anterior]');
  var ahorro = document.querySelector('[data-pu-ahorro]');
  var barraTitulo = document.querySelector('[data-pu-barra-precio]');

  opciones.forEach(function (op) {
    op.addEventListener('click', function () {
      opciones.forEach(function (o) { o.classList.remove('pu-bundle-activo'); });
      op.classList.add('pu-bundle-activo');

      var variantId = op.getAttribute('data-variant-id');
      var precio = op.getAttribute('data-precio');
      var precioComparado = op.getAttribute('data-precio-comparado');
      var precioFmt = op.getAttribute('data-precio-fmt');
      var precioComparadoFmt = op.getAttribute('data-precio-comparado-fmt');

      if (inputId) inputId.value = variantId;
      if (precioActual) precioActual.textContent = precioFmt;
      if (barraTitulo) barraTitulo.textContent = precioFmt;

      if (precioComparado && parseFloat(precioComparado) > parseFloat(precio)) {
        if (precioAnterior) { precioAnterior.textContent = precioComparadoFmt; precioAnterior.style.display = ''; }
        var pct = Math.round((1 - (parseFloat(precio) / parseFloat(precioComparado))) * 100);
        if (ahorro && pct > 0) { ahorro.textContent = 'Ahorras ' + pct + '%'; ahorro.style.display = ''; }
        else if (ahorro) { ahorro.style.display = 'none'; }
      } else {
        if (precioAnterior) precioAnterior.style.display = 'none';
        if (ahorro) ahorro.style.display = 'none';
      }
    });
  });
}

// ---------- Selector de cantidad ----------
function initCantidad() {
  var caja = document.querySelector('[data-pu-cantidad]');
  if (!caja) return;
  var input = caja.querySelector('input');
  var menos = caja.querySelector('[data-pu-menos]');
  var mas = caja.querySelector('[data-pu-mas]');
  if (menos) menos.addEventListener('click', function () {
    var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    input.value = v;
  });
  if (mas) mas.addEventListener('click', function () {
    var v = (parseInt(input.value, 10) || 1) + 1;
    input.value = v;
  });
}

// ---------- FAQ acordeón ----------
function initFaq() {
  var items = document.querySelectorAll('[data-pu-faq-item]');
  if (!items.length) return;
  items.forEach(function (item) {
    var pregunta = item.querySelector('[data-pu-faq-pregunta]');
    var respuesta = item.querySelector('[data-pu-faq-respuesta]');
    if (!pregunta || !respuesta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('pu-faq-abierto');
      items.forEach(function (i) {
        i.classList.remove('pu-faq-abierto');
        var r = i.querySelector('[data-pu-faq-respuesta]');
        if (r) r.style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('pu-faq-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

// ---------- Barra de compra fija (móvil) ----------
function initBarraFija() {
  var barra = document.querySelector('[data-pu-barra-fija]');
  var referencia = document.querySelector('[data-pu-cta-principal]');
  if (!barra || !referencia) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        barra.classList.remove('pu-barra-visible');
      } else if (entry.boundingClientRect.top < 0) {
        barra.classList.add('pu-barra-visible');
      } else {
        barra.classList.remove('pu-barra-visible');
      }
    });
  }, { threshold: 0 });
  obs.observe(referencia);
}
